import React from "react";
import PropTypes from "prop-types";

import { Grid } from "semantic-ui-react";
import { formatDate } from "utils";

import BlobLink from "components/BlobLink";

export function PrivacyPolicyRow({ policy, acceptedTime }) {
  const dateFormatter = formatDate("simpleDate");

  return (
    <Grid.Row style={{ padding: ".25em 0" }}>
      <Grid.Column>
        <div
          style={{
            color: "grey",
            fontWeight: "bold",
            textDecoration: "underline",
          }}
        >
          <BlobLink to={policy.text}>{policy.name}</BlobLink>
        </div>
      </Grid.Column>
      <Grid.Column data-test="accepted-on-column">
        {dateFormatter(new Date(acceptedTime))}
      </Grid.Column>
    </Grid.Row>
  );
}

PrivacyPolicyRow.propTypes = {
  policy: PropTypes.shape({
    name: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  acceptedTime: PropTypes.string.isRequired,
};

export default PrivacyPolicyRow;
